import * as React from 'react'
import { Box } from '@mui/material';
import { formatPercentage } from "@ui-seeker/utils";

export default function percentageColumn(name, label) {
	return {
		name: name, label: label,
		options: {
			filter: false,
			customBodyRowRenderLite: (value, { currency,  ...dataRow }) => {
				return <Box sx={{ textAlign: 'center' }}>
				    {formatPercentage(value, { decimals: 2 })}
				</Box>
			}
		}
	}
}